export default __webpack_public_path__ + "static/measure-1c8770d2f4bf04f73a6043a44da88136.png";